module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-pinterest-twitter-facebook/gatsby-browser.js'),
      options: {"plugins":[],"facebook":{"enable":true,"containerSelector":null,"profile":null,"width":null,"height":null,"tabs":"timeline, events, messages","hideCover":false,"showFacepile":true,"smallHeader":false,"adaptContainerWidth":true}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
